import React from "react";
import "./FeaturesPoP.css";
import image1 from "../../assets/FeaturesPop/Group 1.svg";
import image2 from "../../assets/FeaturesPop/Ellipse 4168 (1).svg";
import icon1 from "../../assets/FeaturesPop/image 74712.svg";
import icon2 from "../../assets/FeaturesPop/image.svg";
import icon3 from "../../assets/FeaturesPop/image (1).svg";
import icon4 from "../../assets/FeaturesPop/image (2).svg";
import icon5 from "../../assets/FeaturesPop/image (3).svg";
import icon6 from "../../assets/FeaturesPop/image (4).svg";

function FeaturesPop() {
  return (
    <div>
      <div className="features_outer">
        <div className="features_left">
          <div className="features_l1">
            <div className="features_circle">
              <img src={icon1} alt="icon1" />
            </div>
            <div className="features_content">
              <h1 className="features_heading">Invoice Management </h1>
              <p className="features_para">
                Streamline invoicing by automating creation, tracking, and
                reminders, reducing manual errors and speeding up payment
                cycles.{" "}
              </p>
            </div>
          </div>
          <div className="features_l1">
            <div className="features_circle">
            <img src={icon3} alt="icon3" />
            </div>
            <div className="features_content">
              <h1 className="features_heading">Proposal Quotations </h1>
              <p className="features_para">
                Create polished, professional proposals and quotations quickly,
                helping you close deals faster and make a lasting impression.{" "}
              </p>
            </div>
          </div>
          <div className="features_l1">
            <div className="features_circle">
            <img src={icon5} alt="icon5" />
            </div>
            <div className="features_content">
              <h1 className="features_heading">Hiring Process </h1>
              <p className="features_para">
                Optimize your recruitment workflow by job postings, applicant
                tracking, and communication, making the hiring process faster
                and more effective.{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="features_right">
          <div className="features_l1">
            <div className="features_circle">
            <img src={icon2} alt="icon2" />
            </div>
            <div className="features_content">
              <h1 className="features_heading">Attendance Management </h1>
              <p className="features_para">
                Accurately monitor employee attendance and generate automated
                reports to simplify compliance and improve workforce management.{" "}
              </p>
            </div>
          </div>
          <div className="features_l1">
            <div className="features_circle">
            <img src={icon4} alt="icon4" />
            </div>
            <div className="features_content">
              <h1 className="features_heading">Finance Management </h1>
              <p className="features_para">
                Centralize financial processes like Revenue, Expnses, and
                accounting to maintain clarity and ensure financial stability.{" "}
              </p>
            </div>
          </div>
          <div className="features_l1">
            <div className="features_circle1"><img src={icon6} alt="icon6" /></div>
            <div className="features_content">
              <h1 className="features_heading">Chat Management </h1>
              <p className="features_para">
                Improve team communication and collaboration with an integrated
                chat solution that keeps everyone connected and informed in real
                time.{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturesPop;
